import { InjectionToken } from "@angular/core";

import { LazyImageConfig } from "./model";

export const GLOBAL_LAZY_IMAGE_CONFIG = new InjectionToken<LazyImageConfig>("lazyImageConfig");

/**
 * @internal
 */
export const _GLOBAL_LAZY_IMAGE_CONFIG = new InjectionToken<LazyImageConfig | (() => LazyImageConfig)>(
	"_lazyImageConfig"
);
